export enum BfxFindFilterConditionValueParseType {
  None,
  RefArray,
  RefString,
  ExclusiveRefString,
  InnerArray,
  DateEquality,
  ModifyUserComparitor,
}
